import { render, staticRenderFns } from "./ListReceptionVal.vue?vue&type=template&id=1385bc3c&scoped=true&"
import script from "./ListReceptionVal.vue?vue&type=script&lang=js&"
export * from "./ListReceptionVal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1385bc3c",
  null
  
)

export default component.exports